<mf-page title="Nuevo cliente">
  <mf-client
    [clientDto]="clientDto"
    (close)="closeModal()"
    (save)="save($event)" />
</mf-page>
